// Dashboard.tsx
import React from 'react';
import styled from 'styled-components';
import { FaDoorOpen, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const DashboardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f0f0;
`;

const IconLinkContainer = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
  border: 2px solid #000;
  margin: 0 10px;

  @media (max-width: 768px) {
    width: 50%;
  }
`;

const IconDivContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
  border: 2px solid #000;
  margin: 0 10px;

  @media (max-width: 768px) {
    width: 50%;
  }
`;

const IconStyle = styled.div`
  font-size: 10vw;

  @media (max-width: 768px) {
    font-size: 50vw;
  }
`;

const Dashboard: React.FC = () => {
  return (
    <DashboardContainer>
      <IconLinkContainer to="/app">
        <IconStyle>
          <FaDoorOpen />
        </IconStyle>
      </IconLinkContainer>
      <IconLinkContainer to="/users">
        <IconStyle>
          <FaUser />
        </IconStyle>
      </IconLinkContainer>
    </DashboardContainer>
  );
};

export default Dashboard;
